<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add New Company</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%;">
      <v-form ref="addAgentForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-text-field
              outline
              label="Name *"
              required
              v-model="newItem.name"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12>
            <v-text-field
              outline
              label="Mobile *"
              v-model="newItem.mobile"
              required              
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Email"
              v-model="newItem.email"
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12>
            <v-text-field
              outline
              label="Address *"
              v-model="newItem.address"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="ID No *"
              v-model="newItem.id_no"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <!-- <v-textarea v-model="newItem.notes" outline label="Notes"></v-textarea> -->
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>      
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
      >Add</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
export default {
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        // mobile: "",
        // email: "",
        // notes: "",
        address: "",
        id_no: ""
      },
      // categories: []
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addAgentForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addAgentForm.reset();
    },
    resetValidation() {
      this.$refs.addAgentForm.resetValidation();
    },
    clearForm() {
      this.newItem.name= "";
      // this.newItem.mobile  = "";
      // this.newItem.email  = "";
      this.newItem.address = "";
      // this.newItem.notes = "";
    },
    newItemDo() {
      if (this.$refs.addAgentForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/employer", this.newItem).then(res => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    }
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>